import {apiClient} from "./api";
import {CACHE_KEYS} from "./constants/cacheKey";
import {or, reduce} from 'ramda';

export function defaultConfigurations() {
    apiClient.list('api/v2/permissions/').then(response => {
        if (!response.error) {
            const data = response['data']['data']['result'];
            const permissions = Object.keys(data).map(k => {
                return {key: data[k], value: k};
            });
            sessionStorage.setItem(CACHE_KEYS.PERMISSIONS, JSON.stringify(permissions));
        }
    }).catch(error => {
    });
}

export function setAuthTypeConfigs(authType) {
    sessionStorage.setItem(CACHE_KEYS.AUTH_TYPE, JSON.stringify(authType));
}

export function getAuthTypeConfigs() {
    const authType = sessionStorage.getItem(CACHE_KEYS.AUTH_TYPE);
    if (authType) {
        return JSON.parse(authType);
    }
}

export function getPermissions() {
    let permissions = sessionStorage.getItem(CACHE_KEYS.PERMISSIONS);
    return permissions ? JSON.parse(permissions) : [];
}

export function getUserPermission(permissionNumber: string) {
    return parseUserPermission(permissionNumber, 'value');
}

export function getUserPermissionKeys(permissionNumber: string) {
    return parseUserPermission(permissionNumber, 'key');
}

export function combinePermissions(selectedPermission) {
    const permissions = selectedPermission || [];
    return reduce(or, 0, permissions).toString()
}

function parseUserPermission(permissionNumber: string, type: string) {
    const permissions = getPermissions();
    const userPermissions = [];
    permissions.forEach(permission => {
        if ((parseInt(permission['key'], 10) | parseInt(permissionNumber)) === parseInt(permissionNumber)) {
            userPermissions.push(permission[type]);
        }
    });
    return userPermissions;
}
